import { UpdateSensorsBatchItemModel } from '../models/sensorEntityModels';
import { UpdateSensorsBatchItemPayload } from '../models/sensorPayloadModels';

export const updateSensorsBatchListModelToPayload = (data: UpdateSensorsBatchItemModel[]): UpdateSensorsBatchItemPayload[] => {
  return data.map(({ id, visible }) => {
    return {
      id,
      visible,
    };
  });
};
